export default "__VITE_ASSET__DjcePepc__"